module.exports = __webpack_public_path__ + "static/media/heatbliss-1.e2fe8685.jpg";